import { gql } from 'apollo-angular';

/**
 * Slim poll document for the top-bar notifications bell (NBO-2207).
 *
 * Deliberately NOT the Action Hub's GetMyTickets: the bell needs no
 * descriptions, button labels or sources, and a distinct operation name keeps
 * the two surfaces independent (refetch-by-name, network tab triage). Polled
 * every ~60s with fetchPolicy 'no-cache' — results must not accumulate in the
 * Apollo cache or patch the feed's own watchQuery.
 */
export const NotificationTickets = gql`
  query NotificationTickets($input: TicketSearchInput) {
    tickets(input: $input) {
      items {
        id
        titles {
          language
          value
        }
        status
        type
        createdAt
        assignedToAdminUserId
      }
    }
  }
`;
